import * as Yup from 'yup';

const paymentOptionsSchema = () =>
	Yup.object().shape({
		method: Yup.string().required(),
		deposit: Yup.boolean().when('method', {
			is: 'finance',
			then: (schema) => schema.required(),
			otherwise: (schema) => schema.notRequired(),
		}),
	});

export default paymentOptionsSchema;
